import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html',
    styleUrls: ['./multi-select-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiSelectDropdownComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class MultiSelectDropdownComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() list: any;
  @Input() isMultiple: boolean = false;
  @Input() maxItems: number = 3;// number of max items that can be selected in dropdown
  @Input() closeOnSelect: boolean = false;
  @Input() selectedOption: string[] | number[] = []; // variable which gets all option coming from edit button.
  @Input() invalidMessage: string = 'Invalid';// invalid message to show when certain condition goes wrong
  @Input() dropdownLabel: string = 'Default';// label that will be shown on abov dropdown as heading
  @Input() labelToBind: string = 'name';//label that will show on ui during click
  @Input() valueToBind: string = 'name';// value that will go in selectedOption array
  @Input() isDisabled: boolean = false;
  @Output() confirmOption = new EventEmitter();
  @Input() required: boolean = true;
  onChange: any = () => {}; // Handles value changes
  onTouch: any = () => {}; // Handle Touch changes (i.e, touch)

  constructor(private ele: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.selectedOption = changes?.selectedOption?.currentValue;
    }
  }

  ngOnInit(): void {}

  writeValue(value: any) {}

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  fnSetOption() {
    this.confirmOption.emit(this.selectedOption);
  }
}
